module.exports = __webpack_public_path__ + "static/media/list.1e11420c.svg";